<div class="container">
  @if (dataLoading()) {
    <app-loading-animation></app-loading-animation>
  }

  @if (dataAvailable()) {
    <app-table-template
      tableTitle="Share Classes"
      [showTitle]="true"
      [showSearch]="true"
      [showToggle]="false"
      [hasCardView]="true"
      [showPagination]="true"
      [clickableRows]="true"
      [columns]="columns()"
      [currentPage]="currentPage()"
      [sortedOn]="sortField()"
      [sortDescending]="sortOrder() === -1"
      [tableMinWidthInRem]="150"
      (sortChanged)="sort($event)"
      (searchChanged)="search($event)"
      (pageChanged)="page($event)"
      (rowClicked)="rowClicked($event)">
      <app-share-classes-card [currentPage]="currentPage()" (rowClicked)="rowClicked($event)"></app-share-classes-card>
    </app-table-template>
  }

  @if (dataEmpty()) {
    <div class="no-data">No share classes available</div>
  }
</div>
